/* global appData */

function sendMessageToParent(event, detail = {}) {
	parent.postMessage({ event, detail }, `${appData.appPath}`);
}

export default sendMessageToParent;



// WEBPACK FOOTER //
// ./app/public/src/js/signin/frame/utils/sendMessageToParent.js